import { useState } from 'react';
import axios, { AxiosResponse } from 'axios';
import { EntityType, UploadFileStatus } from '../types/mold';
import { fileService } from '../services/api';

interface UseFileUploadResult {
  uploadFiles: (entityType: EntityType, entityId: number, files: File[], metadata?: Record<string, any>) => Promise<AxiosResponse<UploadFileStatus[]>>;
  deleteFile: (fileName: string) => Promise<{ isSuccess: boolean; errorMessage?: string }>;
  isUploading: boolean;
  uploadError: string | null;
  setUploadError: (error: string | null) => void;
}

const useFileUpload = (): UseFileUploadResult => {
  const [isUploading, setIsUploading] = useState(false);
  const [uploadError, setUploadError] = useState<string | null>(null);

  const uploadFiles = async (entityType: EntityType, entityId: number, files: File[], metadata?: Record<string, any>): Promise<AxiosResponse<UploadFileStatus[]>> => {
    setIsUploading(true);
    setUploadError(null);

    try {
      const response = await fileService.uploadFiles(entityType, entityId, files, metadata);
      setIsUploading(false);
      return response;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        setUploadError(error.response?.data?.message || 'ขออภัย ระบบเกิดข้อผิดพลาดระหว่างการอัปโหลดไฟล์');
      } else {
        setUploadError('ขออภัย ระบบเกิดข้อผิดพลาดระหว่างการอัปโหลดไฟล์');
      }
      setIsUploading(false);
      throw error;
    }
  };

  const deleteFile = async (fileName: string): Promise<{ isSuccess: boolean; errorMessage?: string }> => {
    const result = await fileService.deleteFile(fileName);
    
    if (!result.isSuccess && result.errorMessage) {
      setUploadError(result.errorMessage);
    }
    
    return result;
  };

  return { uploadFiles, deleteFile, isUploading, uploadError, setUploadError };
};

export default useFileUpload;
